import FilterActionsComponent from "./FilterActionsComponent";
import { Layout, Card, Divider } from 'antd';
const { Content } = Layout;

const FilterGridComponent = ({ formFilter, onCleanFilters }) => {
    return (
        <>
            <Layout>
                <Content>
                    <Card>
                        <h3 style={{marginTop:0}}>Filtros de búsqueda</h3>
                        <Divider style={{ margin: '10px 0' }} />

                        { formFilter }

                        <FilterActionsComponent 
                            onCleanFilters={onCleanFilters}
                        />
                    </Card>
                </Content>
            </Layout>
        </>
    )
}

export default FilterGridComponent;